import { callApiWithToken } from './base';
import config from '../../config';

export const fetchSiteTypes = async (token: string) =>
  callApiWithToken(`${config.urls.siteTypes}`, token, 'GET');
